export default {
  Group: 'Отдел',
  Office: 'Офис',
  Account: 'Счёт',
  LegalEntity: 'Юр.лицо',
  Department: 'Департамент',
};
